import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pickBy from 'lodash/fp/pickBy';
import forEach from 'lodash/forEach';
import { Checkbox } from '@instructure/ui-checkbox';
import Alert from '../Alert';
import t from '@instructure/quiz-i18n/format-message';
var noop = function noop() {};
var dummyImg = 'https://i.ytimg.com/vi/LgkAebhJ7iE/maxresdefault.jpg';
function clone(children, props) {
  return React.cloneElement(children, pickBy(function (prop) {
    return prop !== void 0;
  }, props));
}
var EditStateProvider = /*#__PURE__*/function (_Component) {
  function EditStateProvider() {
    var _this2;
    _classCallCheck(this, EditStateProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, EditStateProvider, [].concat(args));
    _defineProperty(_this2, "state", {
      itemState: {},
      errorsAreShowing: true
    });
    // storage for the currently ongoing requests
    _defineProperty(_this2, "uploadRequests", null);
    _defineProperty(_this2, "handleUpload", function (id, callback) {
      delete _this2.uploadRequests[id];
      callback(dummyImg);
    });
    _defineProperty(_this2, "handleErrorsAreShowingChange", function (e) {
      _this2.setState({
        errorsAreShowing: e.target.checked
      });
    });
    _defineProperty(_this2, "notifyScreenreader", function (content) {
      return _this2.alert.setAlert(content);
    });
    _defineProperty(_this2, "changeItemState", function (stateMod) {
      _this2.setState(function (state) {
        return {
          itemState: _objectSpread(_objectSpread({}, state.itemState), stateMod)
        };
      });
    });
    _defineProperty(_this2, "cancelMediaUpload", function (id) {
      clearTimeout(_this2.uploadRequests[id]);
      delete _this2.uploadRequests[id];
    });
    _defineProperty(_this2, "mediaUpload", function (file, callback) {
      if (_this2.uploadRequests[file] !== void 0) {
        _this2.cancelMediaUpload(file);
      }
      _this2.uploadRequests[file] = setTimeout(function () {
        return _this2.handleUpload(file, callback);
      }, 2000 + Math.random() * 2000);
    });
    _defineProperty(_this2, "handleAlertRef", function (node) {
      _this2.alert = node;
    });
    return _this2;
  }
  _inherits(EditStateProvider, _Component);
  return _createClass(EditStateProvider, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.uploadRequests = {};
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      forEach(this.uploadRequests, clearTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      console.log('Current State:', this.state.itemState); // eslint-disable-line no-console

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
        ref: this.handleAlertRef
      }), clone(this.props.children, _objectSpread(_objectSpread({}, this.state.itemState), {}, {
        changeItemState: this.changeItemState,
        notifyScreenreader: this.notifyScreenreader,
        cancelMediaUpload: this.cancelMediaUpload,
        errorsAreShowing: this.state.errorsAreShowing,
        openImportModal: noop,
        mediaUpload: this.mediaUpload
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Checkbox, {
        onChange: this.handleErrorsAreShowingChange,
        checked: this.state.errorsAreShowing,
        label: t('Show validation errors')
      })));
    }
  }]);
}(Component);
_defineProperty(EditStateProvider, "propTypes", {
  children: PropTypes.node.isRequired
});
export { EditStateProvider as default };